<div class="cm-sign-up-container">
    @if (!$registrationComplete()) {
        <div class="cm-sign-up-card">
            <div class="cm-sign-up-card-header">Sign up for colormass</div>

            @if (!$showProgressCircle()) {
                <!-- SSO Options (shown first) -->
                @if ($googleSsoLink() || $microsoftSsoLink()) {
                    <div class="cm-sign-up-card-sso">
                        @if ($microsoftSsoLink()) {
                            <a class="cm-sign-in-with-microsoft" [href]="$microsoftSsoLink()">
                                <img class="cm-microsoft-logo" alt="Microsoft logo" ngSrc="assets/images/Microsoft.svg" width="21" height="21" />
                                Sign up with Microsoft
                            </a>
                        }
                        @if ($googleSsoLink()) {
                            <a class="cm-sign-in-with-google" [href]="$googleSsoLink()">
                                <img class="cm-google-logo" alt="Google logo" ngSrc="assets/images/Google.png" width="20" height="20" />
                                Sign up with Google
                            </a>
                        }
                    </div>
                    <div class="cm-or">or</div>
                }
            }

            @if (!$showProgressCircle()) {
                <!-- Email Registration Form -->
                <form class="cm-sign-up-form" name="signUpForm" [formGroup]="signUpForm" novalidate (ngSubmit)="onSignUp()">
                    @let submitAttempted = $submitAttempted();
                    <cm-input-container
                        [matTooltip]="
                            submitAttempted &&
                            (signUpForm.controls.emailFormControl.hasError('email') || signUpForm.controls.emailFormControl.hasError('required'))
                                ? 'Please enter a valid email address'
                                : ''
                        "
                        [warning]="
                            submitAttempted &&
                            (signUpForm.controls.emailFormControl.hasError('email') || signUpForm.controls.emailFormControl.hasError('required'))
                        "
                    >
                        <ng-container cm-top-label>
                            <div class="cm-top-label">Email:</div>
                        </ng-container>
                        <ng-container cm-input>
                            <input placeholder="Enter email" name="email" formControlName="emailFormControl" autofocus class="cm-email" />
                        </ng-container>
                    </cm-input-container>
                    @if ($registrationError()) {
                        <div class="cm-email-error">
                            {{ $registrationError() }}
                            @if ($showLoginLink()) {
                                <a [routerLink]="['/login']" class="cm-login-link">Go to login</a>
                            }
                        </div>
                    }

                    <cm-input-container
                        [matTooltip]="
                            submitAttempted && signUpForm.controls.passwordFormControl.hasError('required')
                                ? 'Password is required'
                                : submitAttempted && signUpForm.controls.passwordFormControl.hasError('minlength')
                                  ? 'Password must be at least 8 characters'
                                  : ''
                        "
                        [warning]="
                            submitAttempted &&
                            (signUpForm.controls.passwordFormControl.hasError('required') || signUpForm.controls.passwordFormControl.hasError('minlength'))
                        "
                    >
                        <ng-container cm-top-label>
                            <div class="cm-top-label">Password:</div>
                        </ng-container>
                        <ng-container cm-input>
                            <input
                                placeholder="Enter password"
                                type="password"
                                name="password"
                                formControlName="passwordFormControl"
                                class="cm-password"
                                (input)="validateConfirmPassword()"
                            />
                        </ng-container>
                    </cm-input-container>
                    @if (submitAttempted && signUpForm.controls.passwordFormControl.hasError("minlength")) {
                        <div class="cm-password-error">Password must be at least 8 characters</div>
                    }

                    <cm-input-container [warning]="submitAttempted && !!$confirmPasswordError()">
                        <ng-container cm-top-label>
                            <div class="cm-top-label">Confirm Password:</div>
                        </ng-container>
                        <ng-container cm-input>
                            <input
                                placeholder="Confirm password"
                                type="password"
                                name="confirmPassword"
                                formControlName="confirmPasswordFormControl"
                                class="cm-confirm-password"
                                (input)="validateConfirmPassword()"
                            />
                        </ng-container>
                    </cm-input-container>
                    @if (submitAttempted && $confirmPasswordError()) {
                        <div class="cm-password-error">{{ $confirmPasswordError() }}</div>
                    }

                    <button class="cm-sign-up-button cm-active" type="submit">
                        <i class="far fa-user-plus"></i>
                        <span>Sign Up</span>
                    </button>
                </form>
                <div class="cm-legal-container">
                    By signing up you agree to the
                    <a class="cm-legal" href="https://www.colormass.com/legal/terms-of-service">colormass Terms of Service</a>.
                </div>

                <div class="cm-login-button-container">Already have an account? <a class="cm-login-button" [routerLink]="['/login']">Log in</a></div>
            } @else {
                <mat-progress-spinner mode="indeterminate" [diameter]="24" color="primary"></mat-progress-spinner>
            }
        </div>
    } @else {
        <div class="cm-sign-up-card">
            <div class="cm-sign-up-card-header">Check your email!</div>
            <div class="cm-sign-up-form">
                <div class="cm-verification-message">
                    We've sent a verification email to <strong>{{ $emailForResend() }}</strong
                    >. Please check your inbox and click the verification link.
                </div>

                @if (!$showProgressCircle()) {
                    <button class="cm-sign-up-button" [class.cm-active]="!$resendDisabled()" [disabled]="$resendDisabled()" (click)="onResendVerification()">
                        Resend Verification Email
                    </button>
                    @if ($resendError()) {
                        <div class="cm-resend-error">{{ $resendError() }}</div>
                    }
                    <a class="cm-reset-password" [routerLink]="['/login']">Back to login</a>
                } @else {
                    <mat-progress-spinner mode="indeterminate" [diameter]="24" color="primary"></mat-progress-spinner>
                }
            </div>
        </div>
    }
</div>
